"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardMedia = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _CardMedia = _interopRequireDefault(require("@material-ui/core/CardMedia"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CardMedia = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CardMedia, _Component);

  var _super = _createSuper(CardMedia);

  function CardMedia() {
    var _this;

    (0, _classCallCheck2.default)(this, CardMedia);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          className = _this$props.className,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["className"]);
      var style = {
        height: _this.props.height
      };
      return /*#__PURE__*/_react.default.createElement(_CardMedia.default, (0, _extends2.default)({}, otherProps, {
        style: style,
        className: (0, _classnames.default)("prmbl-cardMedia", className)
      }));
    });
    return _this;
  }

  return CardMedia;
}(_react.Component);

exports.CardMedia = CardMedia;
(0, _defineProperty2.default)(CardMedia, "propTypes", {
  /**
   * Image/Media to be displayed. Available only with media components.
   * Media components: video, audio, picture, iframe, img
   */
  image: _propTypes.default.string.isRequired,

  /**
   *  media height to be passed to css prop
   */
  height: _propTypes.default.string,

  /**
   *  A single child content element.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string
});
(0, _defineProperty2.default)(CardMedia, "defaultProps", {
  className: ""
});
var _default = CardMedia;
exports.default = _default;